import { darken, type ButtonProps, type SxProps, type Theme } from '@mui/material';

import type { AlertCardSeverity } from 'model/types/alert-card';

export const MERCHANT_SELECT_CARD_WIDTH_VALUES = {
  xs: '100%',
  sm: '100%',
  md: '500px',
  lg: '600px',
  xl: '600px'
};

export const TOP_LIST_TILE_SIZE = 36;
export const TOP_LIST_TILE_SIZE_PX = '36px';
export const IMAGE_L_SIZE_PX = '48px';

/** The native input stays in the accessibility tree and keyboard focus order — only its rendering is
 *  replaced by a card, so `RadioGroup`'s arrow-key navigation and radio semantics still apply. */
export const VISUALLY_HIDDEN_RADIO = { position: 'absolute', width: '1px', height: '1px', p: 0, opacity: 0 };

// Pixel strings: a numeric 1 in `sx` means 100%, which lets the label escape a table's scroll box.
export const VISUALLY_HIDDEN_SX = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
} as const;

export const ALERT_ERROR_BG = '#B3261E';
export const ALERT_ERROR_TEXT = '#FFFFFF';
export const ALERT_WARNING_BG = '#FFFFFF';
export const ALERT_WARNING_BORDER = '#664C00';
export const ALERT_WARNING_TEXT = '#664C00';

export const ALERT_BUTTON_PROPS_BY_SEVERITY: Record<Exclude<AlertCardSeverity, 'success'>, ButtonProps> = {
  error: {
    variant: 'contained',
    color: 'error',
    sx: {
      backgroundColor: ALERT_ERROR_BG,
      color: ALERT_ERROR_TEXT,
      '&:hover': { backgroundColor: darken(ALERT_ERROR_BG, 0.1), color: ALERT_ERROR_TEXT }
    }
  },
  warning: {
    variant: 'outlined',
    sx: {
      backgroundColor: ALERT_WARNING_BG,
      borderColor: ALERT_WARNING_BORDER,
      color: ALERT_WARNING_TEXT,
      '&:hover': { backgroundColor: ALERT_WARNING_BG, borderColor: ALERT_WARNING_BORDER, color: ALERT_WARNING_TEXT }
    }
  },
  info: { variant: 'contained', color: 'primary' }
};

export const ALERT_CARD_DEFAULT_SX: SxProps<Theme> = { mb: 2 };
